export default "__VITE_ASSET__kp7bfaEf__"